import type { CartLineItem } from '@/modules/cart/domain/CartLineItem';

export const getProductCategory = (product: CartLineItem): string => {
  const attributes = product?.variant?.attributes;
  const attributesKeyValue = Object.fromEntries(
    attributes?.map((attr) => [attr.name, attr.value]) ?? []
  );
  const value = attributesKeyValue['primaryCategoryKey'];

  if (typeof value === 'string') return value;

  return '';
};
